<div class="busca-pessoa-dialog">

  <h2 mat-dialog-title class="flex items-center gap-2 bg-pmdf-bg-subtle p-4 border-b border-pmdf-divider">
    <mat-icon class="text-pmdf-primary icon-base">person_search</mat-icon>
    <span class="text-pmdf-text-primary text-lg">Buscar Pessoa</span>
  </h2>

  <mat-dialog-content class="dialog-content">
    <div class="flex flex-col gap-4 mt-4">

      <h3 class="nx-dialog-section-title">Busca por nome</h3>

      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-label>Nome da pessoa</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Digite pelo menos 3 caracteres..."
          autocomplete="off">
        <mat-icon matPrefix class="text-pmdf-muted-55 icon-base">search</mat-icon>
        @if (searchControl.value) {
          <button matSuffix mat-icon-button type="button" (click)="limpar()" aria-label="Limpar">
            <mat-icon class="icon-base">clear</mat-icon>
          </button>
        }
        <mat-hint>Mínimo 3 caracteres para buscar</mat-hint>
      </mat-form-field>

      <!-- Loading -->
      @if (isLoading()) {
        <div class="flex flex-col items-center justify-center py-8 text-pmdf-muted-55">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="mt-3 text-sm">Buscando...</p>
        </div>
      }

      <!-- Erro -->
      @if (erro()) {
        <div class="flex flex-col items-center justify-center py-8 text-pmdf-danger">
          <mat-icon class="icon-3xl">error_outline</mat-icon>
          <p class="mt-2 text-sm">{{ erro() }}</p>
          <button mat-button color="primary" type="button" (click)="buscarPessoa(termoBuscado())" class="mt-2">
            Tentar novamente
          </button>
        </div>
      }

      <!-- Sem resultados -->
      @if (semResultados()) {
        <div class="flex flex-col items-center justify-center py-8 text-pmdf-muted-55">
          <mat-icon class="icon-3xl">person_off</mat-icon>
          <p class="mt-2 text-sm">Nenhuma pessoa encontrada para "{{ termoBuscado() }}"</p>

          @if (permitirCadastroManual()) {
            <div class="mt-4">
              <button mat-raised-button color="primary" type="button" (click)="abrirCadastroManual()">
                <mat-icon class="icon-sm mr-1">person_add</mat-icon>
                Cadastrar
              </button>
            </div>
          }
        </div>
      }

      <!-- Estado inicial -->
      @if (!isLoading() && !erro() && resultados().length === 0 && termoBuscado().length < 3) {
        <div class="flex flex-col items-center justify-center py-8 text-pmdf-muted-55">
          <mat-icon class="icon-3xl">search</mat-icon>
          <p class="mt-2 text-sm">Digite o nome para buscar</p>
        </div>
      }

      <!-- Lista de resultados -->
      @if (temResultados() && !isLoading()) {
        <div class="flex flex-col gap-2">
          <p class="text-sm text-pmdf-muted-55">{{ resultados().length }} pessoa(s) encontrada(s)</p>

          @for (pessoa of resultados(); track pessoa.idInterno) {
            <button
              type="button"
              (click)="selecionarPessoa(pessoa)"
              class="w-full flex items-center gap-3 p-3 rounded-pmdf-card border transition-colors text-left"
              [class]="pessoa.dadosValidados
                ? 'bg-pmdf-bg-subtle hover:bg-pmdf-info-soft border-pmdf-border-subtle hover:border-pmdf-info'
                : 'bg-pmdf-warning-soft hover:bg-pmdf-warning-soft/80 border-pmdf-warning hover:border-pmdf-warning'">

              <div class="shrink-0 w-12 h-12 rounded-full overflow-hidden"
                   [class]="pessoa.dadosValidados ? 'bg-pmdf-bg-muted' : 'bg-pmdf-warning-soft'">
                @if (pessoa.fotoPrincipalUrl) {
                  <app-pessoa-foto
                    [path]="pessoa.fotoPrincipalUrl"
                    [alt]="pessoa.nomeCompleto"
                    imgClass="w-full h-full object-cover">
                  </app-pessoa-foto>
                } @else {
                  <div class="w-full h-full flex items-center justify-center"
                       [class]="pessoa.dadosValidados ? 'text-pmdf-muted-55' : 'text-pmdf-warning'">
                    @if (pessoa.dadosValidados) {
                      <mat-icon class="icon-base">person</mat-icon>
                    } @else {
                      <mat-icon class="icon-base">help_outline</mat-icon>
                    }
                  </div>
                }
              </div>

              <div class="flex-1 min-w-0">
                <p class="font-medium text-pmdf-text-primary truncate">{{ pessoa.nomeCompleto }}</p>

                @if (pessoa.dadosValidados) {
                  @if (pessoa.cpf) {
                    <p class="text-sm text-pmdf-muted-55">CPF: {{ pessoa.cpf | mask: '000.000.000-00' }}</p>
                  }
                } @else {
                  <span class="inline-flex items-center gap-1 text-xs font-medium text-pmdf-warning bg-pmdf-warning-soft px-2 py-0.5 rounded-full">
                    <mat-icon class="icon-xs">info</mat-icon>
                    Dados não validados
                  </span>
                }

                <div class="flex items-center gap-2 text-sm text-pmdf-muted-55">
                  @if (pessoa.idade) {
                    <span>{{ pessoa.idade }} anos</span>
                  }
                  @if (pessoa.dataNascimento) {
                    <span>• {{ pessoa.dataNascimento }}</span>
                  }
                </div>
              </div>

              <div class="flex items-center gap-1 shrink-0">
                @if (!pessoa.dadosValidados) {
                  <mat-icon class="text-pmdf-warning icon-sm">person_search</mat-icon>
                }
                <mat-icon class="text-pmdf-muted-55 icon-sm">chevron_right</mat-icon>
              </div>
            </button>
          }
        </div>
      }

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="px-6 py-4 gap-2 bg-pmdf-bg-subtle border-t border-pmdf-divider mt-2">
    <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  </mat-dialog-actions>

</div>
